import $ from 'jquery'

const handleShowAllClick = (e: JQuery.ClickEvent) => {
  e.preventDefault()
  const $this = $(e.currentTarget)
  $this.parent().find('.matching-items-dropdowns').removeClass('collapsed')
  $this.hide()
}

export const initializeMatchingItems = () => {
  $('.show-all').on('click', handleShowAllClick)
}
